export enum TagColors {
  Primary = "primary",
  Neutral = "neutral",
  PrimaryLight = "primary-light",
  Glass = "glass",
  Wood = "wood",
  Stone = "stone",
  Materia = "materia",
  Metal = "metal",
  Transparent = "transparent",
}

export enum TagDimensions {
  Small = "sm",
  Medium = "md",
  Large = "lg",
}

export enum TagVariants {
  Primary = "primary",
  Light = "light",
}
